import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconChatBot: React.FC<IconProps> = ({ color, width = 17, height = 17 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_5578_32094)">
                <path
                    d="M0.301341 15.1934C0.244175 15.2817 0.246773 15.3961 0.309136 15.4818C0.358506 15.552 0.439058 15.5936 0.522208 15.5936C0.540397 15.5936 0.558586 15.5936 0.579373 15.5884L2.96734 15.0583C3.65592 15.4091 4.42766 15.5936 5.20199 15.5936C7.89657 15.5936 10.0923 13.4213 10.1338 10.7345C11.3031 11.0515 12.5842 10.932 13.6703 10.3811L16.0583 10.9086C16.0765 10.9138 16.0946 10.9138 16.1154 10.9138C16.1986 10.9138 16.2791 10.8722 16.3285 10.802C16.3883 10.7163 16.3909 10.602 16.3363 10.5136L15.3619 8.97274C16.0167 8.11785 16.3753 7.06029 16.3753 5.97414C16.3753 3.25098 14.1614 1.03711 11.4382 1.03711C8.71508 1.03711 6.54798 3.2094 6.50641 5.89359C6.09066 5.77926 5.65412 5.7143 5.20199 5.7143C2.47363 5.7169 0.259766 7.93076 0.259766 10.6539C0.259766 11.7375 0.61835 12.795 1.27575 13.6525L0.301341 15.1934ZM11.433 1.5594C13.8678 1.5594 15.8504 3.542 15.8504 5.97674C15.8504 7.00312 15.4918 8.00352 14.837 8.79085C14.7642 8.8766 14.7564 9.00132 14.8162 9.09486L15.5568 10.2642L13.6859 9.85101C13.6261 9.83802 13.5612 9.84581 13.5066 9.87439C12.4698 10.4253 11.22 10.5318 10.1078 10.1836C9.93115 8.31013 8.69949 6.73808 7.0157 6.06768C7.0157 6.0365 7.0131 6.00532 7.0131 5.97414C7.0131 3.5394 8.99571 1.5568 11.4304 1.5568L11.433 1.5594ZM0.779453 10.6539C0.779453 8.21919 2.76206 6.23658 5.1968 6.23658C7.63153 6.23658 9.61414 8.21919 9.61414 10.6539C9.61414 13.0887 7.63153 15.0713 5.1968 15.0713C4.47443 15.0713 3.75726 14.892 3.12065 14.5516C3.08167 14.5308 3.04009 14.5204 2.99852 14.5204C2.98033 14.5204 2.96214 14.5204 2.94135 14.5256L1.07048 14.9387L1.81103 13.7695C1.8708 13.6733 1.863 13.5512 1.79284 13.4654C1.13804 12.6755 0.779453 11.6751 0.779453 10.6487V10.6539Z"
                    fill="#5C5C5C"
                />
                <path d="M9.35449 4.15723H13.512V4.67691H9.35449V4.15723Z" fill="#5C5C5C" />
                <path d="M9.35449 5.7168H13.512V6.23648H9.35449V5.7168Z" fill="#5C5C5C" />
                <path d="M10.3936 7.27539H13.5117V7.79508H10.3936V7.27539Z" fill="#5C5C5C" />
                <path
                    d="M3.54948 11.1735H4.49012L4.76295 12.2129H5.30083L4.53169 9.28961C4.50051 9.17528 4.39917 9.09473 4.27964 9.09473H3.75996C3.64303 9.09473 3.53909 9.17528 3.50791 9.28961L2.73877 12.2129H3.27665L3.54948 11.1735ZM3.96004 9.61441H4.07956L4.3524 10.6538H3.6872L3.96004 9.61441Z"
                    fill="#5C5C5C"
                />
                <path
                    d="M7.65484 11.6932H7.00523V9.61441H7.65484V9.09473H5.83594V9.61441H6.48555V11.6932H5.83594V12.2129H7.65484V11.6932Z"
                    fill="#5C5C5C"
                />
            </g>
            <defs>
                <clipPath id="clip0_5578_32094">
                    <rect width="16.63" height="16.63" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconChatBot;
